module.exports = __webpack_public_path__ + "assets/img/8.708f1713.png";